import { useCallback } from "react"
import { useState } from "react"

const usePagination = () => {

  const [page, setPage] = useState(1)
  const [perPage, setPerPage] = useState(10)

  const onNext = useCallback(() => {
    setPage(prev => prev + 1)
  }, [page])

  const onPrevious = useCallback(() => {
    if (page > 1) {
      setPage(prev => prev - 1)
    }
  }, [page])

  const resetPage = useCallback(() => {
    setPage(1)
  }, [])

  return {
    page,
    perPage,
    onNext,
    onPrevious,
    resetPage
  }

}

export default usePagination